/**
 * OLDAL-SZINTU PUBLIKUS ADATOK.
 *
 * ────────────────────────────────────────────────────────────────────
 * NINCS KITALALT KAPCSOLATI ADAT.
 *
 * Az ertekek KORNYEZETI VALTOZOBOL jonnek, nem a forrasba egetve. Ket
 * okbol:
 *
 *   1. Egy kitalalt e-mail cim vagy telefonszam rosszabb a semminel: a
 *      latogato ir vagy telefonal, es senki nem valaszol.
 *   2. E-mail-valtaskor ne kelljen forrast modositani es ujra kiadni.
 *
 * ELES BUILDBEN AZ E-MAIL KOTELEZO. A `scripts/check-site-config.mjs`
 * ellenorzi a build elott, es hianynal MEGALLITJA a kiadast. Ami ures
 * marad, az a feluleten meg sem jelenik - nem lesz belole ures oszlop
 * vagy lathatatlan hivatkozas.
 * ────────────────────────────────────────────────────────────────────
 *
 * A nyomtato pontos tipusat SEHOL nem irjuk ki. A vevonek a kepesseg
 * szamit (mekkora darab, milyen anyag, milyen finomsag), nem a gep neve.
 */

const env = (key: string): string =>
  ((import.meta.env as Record<string, string | undefined>)[key] ?? '').trim()

export interface SiteInfo {
  /** Kotelezo eles buildben. Ures string = nem jelenik meg. */
  email: string
  /** Nem kotelezo. */
  phone: string
  /** Nem kotelezo, pl. a szemelyes atvetel varosa. */
  city: string
  /** Nem kotelezo, pl. adoszam a lablecbe. */
  taxNumber: string
}

export const SITE: SiteInfo = {
  email: env('VITE_SITE_EMAIL'),
  phone: env('VITE_SITE_PHONE'),
  city: env('VITE_SITE_CITY'),
  taxNumber: env('VITE_SITE_TAX_NUMBER')
}

/**
 * A KOTELEZO kapcsolati mezok, es hogy megvannak-e.
 *
 * A `scripts/check-site-config.mjs` ugyanezt a listat hasznalja build
 * elott - egy helyen all a szabaly, nem ketto.
 */
export const REQUIRED_CONTACT_KEYS = ['VITE_SITE_EMAIL'] as const

export const missingContactKeys = (): string[] =>
  REQUIRED_CONTACT_KEYS.filter((key) => !env(key))

export const isContactConfigured = SITE.email.length > 0

/*
  Fejlesztes kozben ELEG egy figyelmeztetes: a helyi munkat ne akassza meg,
  hogy meg nincs beallitva az e-mail. Eles buildnel a build-lepes all meg.
*/
if (import.meta.env.DEV && !isContactConfigured) {
  console.warn(
    '[VOXORA] Hiányzik a VITE_SITE_EMAIL. Éles buildben ez megállítja a kiadást. ' +
      'Állítsd be a .env.local fájlban.'
  )
}

/**
 * BANKI UTALASI ADATOK.
 *
 * Ezek NEM titkok - a vevonek epp azert adjuk meg, hogy utalni tudjon. A
 * `VITE_` elotag ezert helyenvalo. Titkos kulcs SOHA nem kaphat `VITE_`
 * elotagot: az a bongeszo kotegbe kerulne.
 */
export const BANK = {
  beneficiary: env('VITE_BANK_BENEFICIARY'),
  accountNumber: env('VITE_BANK_ACCOUNT'),
  iban: env('VITE_BANK_IBAN'),
  bankName: env('VITE_BANK_NAME')
}

export const isBankConfigured = Boolean(BANK.beneficiary && BANK.accountNumber)

/** A gep kepessegei, tipusmegjeloles nelkul. */
export const CAPABILITY = {
  /** Legnagyobb darab egy darabban, mm-ben. */
  maxSize: { x: 260, y: 260, z: 260 },
  /** Legfinomabb es legvastagabb reteg mm-ben. */
  layerRange: { min: 0.08, max: 0.3 },
  technology: 'FDM'
} as const

/**
 * A FOOLDALI SZAKASZOK, amikre a lablec es a fejlec hivatkozik.
 *
 * Egy helyen allnak, mert HAROM oldalrol kell rajuk mutatni (fooldal,
 * `/arbecsles`, `/ajanlat/...`), es kulon oldalon a puszta `#folyamat`
 * hivatkozas SEMMIRE nem mutatna - az aktualis ut nem letezo horgonya
 * lenne.
 */
export const SITE_SECTIONS = [
  { hash: 'folyamat', label: 'Hogyan működik' },
  { hash: 'anyagok', label: 'Anyagok' },
  { hash: 'finomsag', label: 'Felület és részletesség' },
  { hash: 'arak', label: 'Árak' },
  { hash: 'gyik', label: 'Gyakori kérdések' }
] as const
